import React, { useState } from "react";
import { useForm } from "./FormContext";

const Faq = (onOpen) => {
  const { openForm } = useForm();

  const faqs = [
    {
      question: "What is life coaching?",
      answer:
        "Life coaching helps you gain clarity, overcome obstacles, and move toward your personal or professional goals. It's focused on the present and future, supporting positive and sustainable change.",
    },
    {
      question: "How is coaching different from therapy?",
      answer:
        "Coaching is forward-focused and action-oriented. It centers on goals, mindset, and growth, while therapy often explores past experiences and mental health concerns.",
    },
    {
      question: "Who is life coaching for?",
      answer:
        "Coaching is for anyone feeling stuck, overwhelmed, or ready for change-or simply seeking clarity, confidence, or direction.",
    },
    {
      question: "What happens in a coaching session?",
      answer:
        "You'll have a safe, non-judgmental space to explore your goals through thoughtful questions, practical tools, and clear action steps tailored to you.",
    },
    {
      question: "How soon will I see results?",
      answer:
        "Some people gain clarity in a single session, while deeper, lasting change happens with consistent coaching over time.",
    },
    {
      question: "Do you offer online sessions?",
      answer:
        "Yes. Sessions are available online, withFace-to-face options depending on location.",
    },
    {
      question: "Is everything we discuss confidential?",
      answer:
        "Most clients meet weekly or bi-weekly, but timing is flexible based on your needs.",
    },
    {
      question: "Is everything we discuss confidential?",
      answer: "Absolutely. All sessions are fully confidential.",
    },
    {
      question: "How do I know if coaching is right for me?",
      answer:
        "A free discovery call is the best way to explore your goals and see if coaching feels right.",
    },
    {
      question: "How do I get started?",
      answer:
        "Simply book a free discovery call or schedule your first session through the website.",
    },
    {
      question: "What kind of challenges can you help me with?",
      answer: (
        <>
          <p>Coaching can support you with:</p>
          <ul>
            <li>Feeling stuck or lacking direction</li>
            <li>Overthinking and self-doubt</li>
            <li>Career or life transitions</li>
            <li>Building confidence and clarity</li>
            <li>Creating balance and alignment in your life</li>
          </ul>
          <p>
            If you’re unsure, the discovery call is a great place to explore
            your specific situation.
          </p>
        </>
      ),
    },
  ];
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <section id="faq" className="animate">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <h2 className="text-center">Frequently Asked Questions</h2>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-12">
            {faqs.map((faq, index) => {
              const isOpen = activeIndex === index;
              return (
                <div
                  key={index}
                  className="faq-item"
                  style={{
                    marginBottom: "1rem",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  <div
                    className="faq-question animate"
                    onClick={() => toggleAnswer(index)}
                    style={{
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    {faq.question} <span>{isOpen ? "−" : "+"}</span>
                  </div>

                  <div
                    className="faq-answer"
                    style={{
                      display: "grid",
                      gridTemplateRows: isOpen ? "1fr" : "0fr",
                      transition: "grid-template-rows 0.3s ease-out",
                      overflow: "hidden",
                    }}
                  >
                    <div style={{ minHeight: 0 }}>
                      <div style={{ paddingBottom: "1rem" }}>{faq.answer}</div>
                    </div>
                  </div>
                </div>
              );
            })}
            <button
              type="button"
              className="btn-new mt-3"
              onClick={() =>
                openForm({
                  service_title: "Free Discovery Call",
                  duration: "15 minutes",
                  format: "Online",
                })
              }
              style={{ border: "none", cursor: "pointer" }}
            >
              Book a Free Discovery Call
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
